import type { SVGProps } from 'react';
export const IconKitMapZoomMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 17.25C7.5 16.8358 7.83579 16.5 8.25 16.5H26.25C26.6642 16.5 27 16.8358 27 17.25C27 17.6642 26.6642 18 26.25 18H8.25C7.83579 18 7.5 17.6642 7.5 17.25Z"
      fill="currentColor"
    />
  </svg>
);
